import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import { RichTextWrapper } from "./RichText.styles";
export var RichText = function(props) {
    var content = props.content, _rules = props.rules, rules = _rules === void 0 ? {} : _rules;
    var textStyle = rules.textStyle;
    return /*#__PURE__*/ _jsx(RichTextWrapper, {
        rules: rules,
        children: /*#__PURE__*/ _jsx(Ui.RichText, {
            content: content,
            rules: {
                textStyle: textStyle
            }
        })
    });
};
